/**
 * PerplayAdminApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The SystemControllerDtoMnLnbUploadRequest model module.
 * @module model/SystemControllerDtoMnLnbUploadRequest
 * @version 1.0
 */
class SystemControllerDtoMnLnbUploadRequest {
    /**
     * Constructs a new <code>SystemControllerDtoMnLnbUploadRequest</code>.
     * @alias module:model/SystemControllerDtoMnLnbUploadRequest
     * @param gnbNo {Number} 
     * @param lnbName {String} 
     */
    constructor(gnbNo, lnbName) { 
        
        SystemControllerDtoMnLnbUploadRequest.initialize(this, gnbNo, lnbName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, gnbNo, lnbName) { 
        obj['gnbNo'] = gnbNo;
        obj['lnbName'] = lnbName;
    }

    /**
     * Constructs a <code>SystemControllerDtoMnLnbUploadRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/SystemControllerDtoMnLnbUploadRequest} obj Optional instance to populate.
     * @return {module:model/SystemControllerDtoMnLnbUploadRequest} The populated <code>SystemControllerDtoMnLnbUploadRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SystemControllerDtoMnLnbUploadRequest();

            if (data.hasOwnProperty('gnbNo')) {
                obj['gnbNo'] = ApiClient.convertToType(data['gnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbNo')) {
                obj['lnbNo'] = ApiClient.convertToType(data['lnbNo'], 'Number');
            }
            if (data.hasOwnProperty('lnbName')) {
                obj['lnbName'] = ApiClient.convertToType(data['lnbName'], 'String');
            }
            if (data.hasOwnProperty('pageUrl')) {
                obj['pageUrl'] = ApiClient.convertToType(data['pageUrl'], 'String');
            }
            if (data.hasOwnProperty('sort')) {
                obj['sort'] = ApiClient.convertToType(data['sort'], 'Number');
            }
            if (data.hasOwnProperty('enabled')) {
                obj['enabled'] = ApiClient.convertToType(data['enabled'], 'Boolean');
            }
            if (data.hasOwnProperty('key')) {
                obj['key'] = ApiClient.convertToType(data['key'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>SystemControllerDtoMnLnbUploadRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>SystemControllerDtoMnLnbUploadRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of SystemControllerDtoMnLnbUploadRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['lnbName'] && !(typeof data['lnbName'] === 'string' || data['lnbName'] instanceof String)) {
            throw new Error("Expected the field `lnbName` to be a primitive type in the JSON string but got " + data['lnbName']);
        }
        // ensure the json data is a string
        if (data['pageUrl'] && !(typeof data['pageUrl'] === 'string' || data['pageUrl'] instanceof String)) {
            throw new Error("Expected the field `pageUrl` to be a primitive type in the JSON string but got " + data['pageUrl']);
        }
        // ensure the json data is a string
        if (data['key'] && !(typeof data['key'] === 'string' || data['key'] instanceof String)) {
            throw new Error("Expected the field `key` to be a primitive type in the JSON string but got " + data['key']);
        }

        return true;
    }


}

SystemControllerDtoMnLnbUploadRequest.RequiredProperties = ["gnbNo", "lnbName"];

/**
 * @member {Number} gnbNo
 */
SystemControllerDtoMnLnbUploadRequest.prototype['gnbNo'] = undefined;

/**
 * @member {Number} lnbNo
 */
SystemControllerDtoMnLnbUploadRequest.prototype['lnbNo'] = undefined;

/**
 * @member {String} lnbName
 */
SystemControllerDtoMnLnbUploadRequest.prototype['lnbName'] = undefined;

/**
 * @member {String} pageUrl
 */
SystemControllerDtoMnLnbUploadRequest.prototype['pageUrl'] = undefined;

/**
 * @member {Number} sort
 */
SystemControllerDtoMnLnbUploadRequest.prototype['sort'] = undefined;

/**
 * @member {Boolean} enabled
 */
SystemControllerDtoMnLnbUploadRequest.prototype['enabled'] = undefined;

/**
 * @member {String} key
 */
SystemControllerDtoMnLnbUploadRequest.prototype['key'] = undefined;






export default SystemControllerDtoMnLnbUploadRequest;

